import { render } from "./IconListFile.vue?vue&type=template&id=7f35869a"
import script from "./IconListFile.vue?vue&type=script&lang=ts"
export * from "./IconListFile.vue?vue&type=script&lang=ts"
script.render = render

export default script